import React from 'react';
import { BiFontSize } from 'react-icons/bi';
import { Link } from 'react-router-dom';

function BlogThreeItem({ thumb, meta, title, category, slug }) {
    const linkPath = `/services/${slug}`;

    return (
        <div className="col-xl-3 col-md-6 col-12 mb-4">
            <Link to={linkPath}>
                <div className="single-news-card h-100 d-flex flex-column">
                    <div
                        className="featured-thumb bg-cover"
                        style={{ backgroundImage: `url(${thumb})` }}
                    />

                    <div className="post-content flex-grow-1 d-flex flex-column">
                        <div className="post-date ml-2">
                            <span>{meta}</span>
                        </div>

                        <h3 style={{ textTransform: 'capitalize' }}>
                            {title}
                        </h3>

                        <Link
                            className="read-btn"
                            to={linkPath}
                        >
                            Read More
                        </Link>
                    </div>
                </div>
            </Link>
        </div>
    );
}

export default BlogThreeItem;